import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "pdfFrame", "confirmButton"]
  static values = { patientId: String }

  connect() {
    document.addEventListener("show-invoice-preview", this.handleShowPreview.bind(this))
  }

  disconnect() {
    document.removeEventListener("show-invoice-preview", this.handleShowPreview.bind(this))
  }

  handleShowPreview(event) {
    this.form = event.detail.form
    this.openModal()
    this.loadPreview()
  }

  openModal() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
    this.pdfFrameTarget.src = ""
  }

  loadPreview() {
    const formData = new FormData(this.form)
    const params = new URLSearchParams(formData)
    const url = `/receptionist/cash/${this.patientIdValue}/preview_payment?${params}`
    
    this.pdfFrameTarget.src = url
    this.confirmButtonTarget.disabled = false
  }

  confirmPayment() {
    this.closeModal()
    this.form.submit()
  }
}

